<template>
    <div>
        <div class="row">
            <div class="col" v-if="!HideTopLeft">
                <a class="text-subtitle2">{{LabelTopLeft}}</a><br>
                <a class="text-caption">{{ValueTopLeft}}</a>
            </div>
            <div class="col" v-if="!HideTopRight">
                <a class="text-subtitle2">{{LabelTopRight}}</a><br>
                <a class="text-caption">{{ValueTopRight}}</a>
            </div>
        </div>
        <div class="row">
            <div class="col" v-if="!HideMiddleLeft">
                <a class="text-subtitle2">{{LabelMiddleLeft}}</a><br>
                <a class="text-caption">{{ValueMiddleLeft}}</a>
            </div>
            <div class="col" v-if="!HideMiddleRight">
                <a class="text-subtitle2">{{LabelMiddleRight}}</a><br>
                <a class="text-caption">{{ValueMiddleRight}}</a>
            </div>
        </div>
        <div class="row">
            <div class="col" v-if="!HideBottomLeft">
                <a class="text-subtitle2">{{LabelBottomLeft}}</a><br>
                <a class="text-caption">{{ValueBottomLeft}}</a>
            </div>
            <div class="col" v-if="!HideBottomRight">
                <a class="text-subtitle2">{{LabelBottomRight}}</a><br>
                <a class="text-caption">{{ValueBottomRight}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FI-Info',
    props: [
        'LabelTopLeft',
        'ValueTopLeft',
        'LabelTopRight',
        'ValueTopRight',
        'LabelBottomLeft',
        'ValueBottomLeft',
        'LabelBottomRight',
        'ValueBottomRight',
        'LabelMiddleLeft',
        'ValueMiddleLeft',
        'LabelMiddleRight',
        'ValueMiddleRight',
        'HideTopLeft',
        'HideTopRight',
        'HideBottomLeft',
        'HideBottomRight',
        'HideMiddleLeft',
        'HideMiddleRight'
    ],
    components:{
    },
    data () {
        return {
        
        }
    },
    methods:{
        
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
